import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-list_icon",
  "use": "icon-list_icon-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-list_icon\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h32v32H0z\" /><path d=\"M4 5.333h24V8H4V5.333Zm0 9.334h24v2.666H4v-2.666ZM4 24h24v2.667H4V24Z\" fill=\"#FFF\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol